<template>
<div class="bg_white">
  <div v-model="opacity" :style="{opacity: opacity}" v-if="isShow" id="credit" class="add_credit  pt15 pr16 pl16">
      <div class="btn_center" v-if="isRedirect == 'purchaseSelectPaymentAndShipping'">
        <router-link id="js-showBtn" class="btn_delete hide" :to="{ name: 'purchaseSelectPaymentAndShipping', query: {status: 'addCreditCard'} }">戻る</router-link>
      </div>
      <div class="btn_center" v-else-if="isRedirect == 'repeatSelectPaymentAndShipping'">
        <router-link id="js-showBtn" class="btn_delete hide" :to="{ name: 'repeatSelectPaymentAndShipping', query: {status: 'addCreditCard'} }">戻る</router-link>
      </div>
      <div class="btn_center" v-else-if="isRedirect == 'NSelectionSelectPaymentAndShipping'">
        <router-link id="js-showBtn" class="btn_delete hide" :to="{ name: 'NSelectionSelectPaymentAndShipping', query: {status: 'addCreditCard'} }">戻る</router-link>
      </div>
    <div id="parent"></div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>

  <p id="message" class="message c5a mt20 pl16 pr16"></p>
  <div v-if="isRedirect == 'purchaseSelectPaymentAndShipping'">
    <router-link id="redirectUrl" :to="{ name: 'purchaseSelectPaymentAndShipping', query: {status: 'addCreditCard'} }"></router-link>
  </div>
  <div v-else-if="isRedirect == 'repeatSelectPaymentAndShipping'">
    <router-link id="redirectUrl" :to="{ name: 'repeatSelectPaymentAndShipping', query: {status: 'addCreditCard'} }"></router-link>
  </div>
  <div v-else-if="isRedirect == 'NSelectionSelectPaymentAndShipping'">
    <router-link id="redirectUrl" :to="{ name: 'NSelectionSelectPaymentAndShipping', query: {status: 'addCreditCard'} }"></router-link>
  </div>
</div>


</template>
<!-- <script src="https://widget.gyro-n.money/client/checkout.js"></script> -->
<script>
import Gyronpay from '@/components/api/gyronpay'
import creditCard from '@/components/api/creditCard'
import Check from '@/model/getToken'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      message: 'aaa',
      opacity: 1,
      isShow: true,
      isRedirect: this.$route.query.redirect_url,
      appToken: '',
      showBackBtn: false,
    }
  },
  methods: {
    async apiGetGuronPay() {
      // console.log('apiGetGuronPay');
      return await Gyronpay.getGyronpayParameter();
    },
    async makeGyron() {
      let gyronData = this.apiGetGuronPay();
      await gyronData.then((val) => {
        this.appToken = val.applicationToken;

        let script_list = document.getElementsByTagName('script');
        let exist_script = [...script_list].some(function(val) {
          return val.src == 'https://widget.gyro-n.money/client/checkout.js'
        });
        //scriptタグがなければ生成する
        console.log(exist_script);
        if(!exist_script) {
          let recaptchaScript = document.createElement('script');
          recaptchaScript.setAttribute('src', val.widgetUrl);
          document.head.appendChild(recaptchaScript);
        }
      });
			console.log('makeGyron start');
      let create_span = document.createElement('span');
      create_span.dataset.app_id = this.appToken;
      create_span.dataset.checkout = "token";
      create_span.dataset.header = "ナチュラリープラス";
      create_span.dataset.auto_close = "true";
      create_span.dataset.text = "カード登録";
      create_span.dataset.name = "transactionToken";
      create_span.dataset.locale = "ja-JP";
      create_span.dataset.token_type = "recurring";
      create_span.dataset.show_cvv = "true";

      let parent = document.getElementById('parent');
      parent.appendChild(create_span);

			console.log('makeGyron end');
		},
  },
  computed: mapGetters(['reloadCheck']),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      let btnShow = this.showBackBtn;
      this.makeGyron();
      // const target = document.getElementsByTagName('body')[0];
      const target = document.getElementById('credit');
      var mo = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation){
          mutation.addedNodes.forEach(node => {
            if (node.name == 'transactionToken') {
              creditCard.addCreditCard(node.defaultValue).then((val) => {
                if(val == 'OK') {
                  let redirectButton = document.getElementById('redirectUrl');
                  if(redirectButton) {
                    redirectButton.click();
                  } else {
                    document.getElementById('message').textContent = 'クレジットカードの追加が完了しました。';
                  }
                } else {
                  document.getElementById('message').textContent = 'クレジットカードの追加に失敗しました。';
                }
              });
						} else if (node.tagName == 'BUTTON') {
							console.log('button追加');
              let button_list = document.getElementsByTagName('button');
              for (let i = 0; i < button_list.length; i++) {
                if(button_list[i].innerText == 'カード登録') {
                  button_list[i].click();
                  let backbtn = document.getElementById('js-showBtn');
                  backbtn.classList.remove('hide');
                  backbtn.classList.add('show');

                  // // 戻るボタンを表示する
                  // setTimeout(function() {
                  //   let backbtn = document.getElementById('js-showBtn');
                  //   backbtn.classList.remove('hide');
                  //   backbtn.classList.add('show');
                  // }, 3000);
                }
              }
						}
					});

          /* iframeを閉じた際にカード一覧ページへ遷移する際に必要（targetをbodyにする必要がある） */
          // mutation.removedNodes.forEach(node => {
          //   // console.log(node);
          //   // iframeを閉じた場合に発火する
          //   if (node.name == 'univapay-checkout-connector') {
          //     let redirectButton = document.getElementById('redirectUrl');
          //     if(redirectButton) {
          //       redirectButton.click();
          //     } else {
          //       document.getElementById('message').textContent = '戻るボタンを押して再度開き直してください。';
          //     }
          //     let iframe = document.getElementsByTagName('iframe');
          //     console.log(iframe);
          //     for (let i = 0; i < iframe.length; i++) {
          //       if(iframe[i].name == 'univapay-checkout-connector') {
          //         iframe[i].remove();
          //       }
          //     }
					// 	}
					// });
        });
      });
      mo.observe(target, { childList: true, subtree: true });

      // 戻るボタンを表示する
      this.showBackBtn = true;
    } else {
      this.isShow = false;
    }


  },
}
</script>

<style lang="css" scoped>
.btn_delete {
  /* margin-top: 25px; */
  margin: auto;
}
.btn_center {
  align-items: center;
  display: flex;
  justify-content: center;
  max-height: 100%;
  height: 100vw;
}
.hide {
  display: none;
}
.show {
  display: block;
}
/* .add_credit {
  padding-bottom: 100px;
} */
>>> button {
  /* opacity: 0; */
  display: none;
}
.form_border {
  border-bottom: 2px solid  #c9c9c9;
  padding-bottom: 12px;
}
.page_title {
  border-left: 4px solid #4FCCD4;
  color: #5a5a5a;
  font-size: 16px;
  padding-left: 4px;
}
.contents {
  display: block;
  margin-top: 35px;
}
.contents_title {
  font-size: 12px;
  color: #878787;
}

.credit_wrap {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  margin-top: 17px;
  padding: 0 8px 16px;
}
.image {
  max-width: 65px;
}
.image:not(:first-child) {
  margin-left: 30px;
}

.card_number {
  border: none;
  color: #5a5a5a;
  font-size: 16px;
  margin-top: 10px;
  width: 100%;
}

.item_wrap {
  align-items: center;
  display: flex;
  padding-bottom: 6px;
  width: 46%;
}
.item_select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  background-color: transparent;
  color: #5a5a5a;
  font-size: 16px;
  width: 100%;
}
.contents_text {
  color: #878787;
  font-size: 16px;
  width: 50%;
}

.select_wrap {
  width: 50%;
}

.flex_wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.bottom_arrow::after {
  height: 6px;
  right: 10px;
  top: 5px;
  width: 6px;
}
.yourname {
  background-color: transparent;
}
.kodomo_wrap {
  font-size: 16px;
  margin-top: 53px;
  text-align: center;
}

.form_submit {
  letter-spacing: 17.5px;
  margin-top: 70px;
  text-indent: 17.5px;
}

</style>



// WEBPACK FOOTER //
// src/views/member/AddCreditCard.vue